/**
 * Salt-okunur dökümantasyon registry.
 * Yeni dökümanlar buraya eklenir; panelden CRUD yok.
 */

/** @typedef {{ title: string, body: string, image?: string }} DocStep */
/** @typedef {{
 *   slug: string,
 *   title: string,
 *   platform: string,
 *   role: string,
 *   summary: string,
 *   steps: DocStep[],
 * }} DocArticle */
/** @typedef {{ slug: string, title: string, docs: DocArticle[] }} DocSubcategory */
/** @typedef {{ slug: string, title: string, subcategories: DocSubcategory[] }} DocCategory */

/** @type {DocCategory[]} */
export const DOCS_TREE = [
  {
    slug: 'mobileapp',
    title: 'MobileApp',
    subcategories: [
      {
        slug: 'teknisyen',
        title: 'Teknisyen',
        docs: [
          {
            slug: 'yasal-onay',
            title: 'Yasal Onay',
            platform: 'MobileApp',
            role: 'Teknisyen',
            summary:
              'Uygulama açılışında yasal kapı: dil seçimi (TR/EN), belge okuma, onay kutuları, giriş ve müşteri verileri taahhütnamesi. Dil değişince arayüz ve belge metinleri birlikte değişir.',
            steps: [
              {
                title: '1. Yasal karşılama (TR)',
                body: 'İlk açılışta logo, kısa açıklama ve üç belge linki görünür. Sağ üstten dil seçilir. İki onay kutusu işaretlenmeden devam edilmez.',
                image: '/dokumantasyon/mobileapp/teknisyen/yasal-onay/step-1.png',
              },
              {
                title: '2. Dil seçimi — English',
                body: 'English seçilince açıklama, belge başlıkları, onay metinleri ve buton İngilizceye döner. Onay kutuları sıfırlanır; belgeler sunucudan ?lang=en ile yeniden yüklenir.',
                image: '/dokumantasyon/mobileapp/teknisyen/yasal-onay/step-2.png',
              },
              {
                title: '3. Belge okuma (TR)',
                body: 'Kullanım Koşulları / KVKK / Gizlilik linkinden metin okunur. Sürüm bilgisi üstte görünür.',
                image: '/dokumantasyon/mobileapp/teknisyen/yasal-onay/step-3.png',
              },
              {
                title: '3.a. Belge okuma (EN)',
                body: 'Dil English iken aynı belge İngilizce gövde ve başlıkla açılır. Hash kabulü TR veya EN gövdeye göre yapılır.',
                image: '/dokumantasyon/mobileapp/teknisyen/yasal-onay/step-3a.png',
              },
              {
                title: '4. Giriş (TR)',
                body: 'Onaylardan sonra giriş ekranı gelir. Dil Türkçe ise alanlar ve Giriş Yap butonu Türkçedir.',
                image: '/dokumantasyon/mobileapp/teknisyen/yasal-onay/step-4.png',
              },
              {
                title: '4.a. Giriş (EN)',
                body: 'Yasal ekranda English seçildiyse giriş ekranı da İngilizce açılır (Username, Password, Sign In).',
                image: '/dokumantasyon/mobileapp/teknisyen/yasal-onay/step-4a.png',
              },
              {
                title: '5. Taahhütname (TR)',
                body: 'Teknisyen girişinden sonra Müşteri Verileri Taahhütnamesi zorunludur. Onay kutusundan sonra Kabul ve taahhüt ediyorum ile devam edilir.',
                image: '/dokumantasyon/mobileapp/teknisyen/yasal-onay/step-5.png',
              },
              {
                title: '5.a. Taahhütname (EN)',
                body: 'Dil English iken taahhüt metni ve butonlar İngilizce görünür (Customer Data Undertaking).',
                image: '/dokumantasyon/mobileapp/teknisyen/yasal-onay/step-5a.png',
              },
              {
                title: '6. Bildirim izni',
                body: 'Taahhüt sonrası bildirim ön-açıklaması sorulabilir. Şimdi değil veya Devam Et ile ilerlenir.',
                image: '/dokumantasyon/mobileapp/teknisyen/yasal-onay/step-6.png',
              },
              {
                title: '7. Anasayfa',
                body: 'Teknisyen anasayfasında rol Teknisyen görünür; randevu listesi açılır.',
                image: '/dokumantasyon/mobileapp/teknisyen/yasal-onay/step-7.png',
              },
            ],
          },
          {
            slug: 'login-1',
            title: 'Login - 1',
            platform: 'MobileApp',
            role: 'Teknisyen',
            summary:
              'Teknisyen hesabıyla uygulamaya ilk giriş: kullanıcı adı/şifre ve anasayfa (Randevular).',
            steps: [
              {
                title: '1. Giriş ekranı',
                body: 'Yasal onaydan sonra SM Yönetim Sistemi giriş ekranı açılır.',
                image: '/dokumantasyon/mobileapp/teknisyen/login-1/step-1.png',
              },
              {
                title: '2. Bilgileri girme',
                body: 'Teknisyen kullanıcı adı ve şifresini girip Giriş Yap’a basın.',
                image: '/dokumantasyon/mobileapp/teknisyen/login-1/step-2.png',
              },
              {
                title: '3. Anasayfa',
                body: 'Giriş sonrası üstte Teknisyen rolü ve Randevular listesi görünür.',
                image: '/dokumantasyon/mobileapp/teknisyen/login-1/step-3.png',
              },
            ],
          },
          {
            slug: 'kurulum-1',
            title: 'Kurulum - 1',
            platform: 'MobileApp',
            role: 'Teknisyen',
            summary:
              'Kurulum randevusunu teknisyen sihirbazında adım adım tamamlama: cihaz kaydı, kontrol listesi, işlemler, ilk çalıştırma ve OTP.',
            steps: [
              {
                title: '1. Bilgi',
                body: 'Randevu, müşteri ve kurulum ürün bilgisini kontrol edin. Durum uygunsa İşleme Başla ile Cihaz adımına geçin.',
                image: '/dokumantasyon/mobileapp/teknisyen/kurulum-1/step-1.png',
              },
              {
                title: '2. Cihaz',
                body: 'Katalogdan ürünü seçin, seri numarasını girin ve Cihazı Onayla ile onaylayın.',
                image: '/dokumantasyon/mobileapp/teknisyen/kurulum-1/step-2.png',
              },
              {
                title: '3. Liste',
                body: 'Kontrol listesi sorularını yanıtlayın. Evet seçilen sorularda istenen değerleri girin; ardından İşlem adımına geçin.',
                image: '/dokumantasyon/mobileapp/teknisyen/kurulum-1/step-3.png',
              },
              {
                title: '3.a. Garanti kapsamı',
                body: 'Listenin altında Garanti dahilinde mi? sorusunu Evet olarak işaretleyin.',
                image: '/dokumantasyon/mobileapp/teknisyen/kurulum-1/step-3a.png',
              },
              {
                title: '4. İşlem',
                body: 'En az bir yapılan veya ilave işlem ekleyin. Kurulumda parça bölümü yoktur; gerekirse fotoğraf ekleyin.',
                image: '/dokumantasyon/mobileapp/teknisyen/kurulum-1/step-4.png',
              },
              {
                title: '4.a. İşlem ekleme',
                body: '+ İşlem Ekle ile işlem kataloğunu açın. Kategoriler listelenir; ilgili grubu genişletin.',
                image: '/dokumantasyon/mobileapp/teknisyen/kurulum-1/step-4-add.png',
              },
              {
                title: '4.b. İşlem seçimi',
                body: 'Uygun işlemleri işaretleyin. Seçim sonrası kaydederek randevu işlem listesine eklenir.',
                image: '/dokumantasyon/mobileapp/teknisyen/kurulum-1/step-4-select.png',
              },
              {
                title: '4.c. Eklenen işlemler',
                body: 'Kaydedilen yapılan işlemler İşlem adımında listelenir. Gerekirse silip yeniden ekleyebilirsiniz.',
                image: '/dokumantasyon/mobileapp/teknisyen/kurulum-1/step-4-listed.png',
              },
              {
                title: '5. Tamam',
                body: 'İlk çalıştırmayı işaretleyin. Müşteri ve iç teknisyen notlarını girip Son Adıma Geç ile OTP adımına ilerleyin.',
                image: '/dokumantasyon/mobileapp/teknisyen/kurulum-1/step-5.png',
              },
              {
                title: '6. OTP',
                body: 'Konum Doğrula ve OTP Doğrula adımlarını tamamlayın. Her ikisi doğrulanınca Randevu Tamamla ile bitirin.',
                image: '/dokumantasyon/mobileapp/teknisyen/kurulum-1/step-6.png',
              },
            ],
          },
          {
            slug: 'kurulum-2',
            title: 'Kurulum - 2',
            platform: 'MobileApp',
            role: 'Teknisyen',
            summary:
              'Kontrol listesinde en az bir Hayır olduğunda (şartlar sağlanmadı): işlem bedeli, müşteri ödemesi, konum ve OTP ile tamamlama.',
            steps: [
              {
                title: '1. Bilgi',
                body: 'Randevu ve müşteri bilgisini kontrol edin. İşleme Başla ile Cihaz adımına geçin.',
                image: '/dokumantasyon/mobileapp/teknisyen/kurulum-2/step-1.png',
              },
              {
                title: '2. Cihaz',
                body: 'Ürünü ve seri numarasını onaylayın.',
                image: '/dokumantasyon/mobileapp/teknisyen/kurulum-2/step-2.png',
              },
              {
                title: '3. Liste',
                body: 'Kontrol sorularını yanıtlayın. En az bir soruya Hayır verildiğinde garanti şartları sağlanmamış sayılır.',
                image: '/dokumantasyon/mobileapp/teknisyen/kurulum-2/step-3.png',
              },
              {
                title: '4. İşlem',
                body: 'Bedelli yapılan işlem ekleyin. Tahsilat tutarı seçilen işlemlerden hesaplanır.',
                image: '/dokumantasyon/mobileapp/teknisyen/kurulum-2/step-4.png',
              },
              {
                title: '5. Tamam',
                body: 'Kontrol listesi karşılanmadı uyarısını ve tahsilat tutarını kontrol edin. Notları girip Son Adıma Geç ile ilerleyin.',
                image: '/dokumantasyon/mobileapp/teknisyen/kurulum-2/step-5.png',
              },
              {
                title: '6. Ödeme',
                body: 'Müşteri Ödemesi bölümünde Ödeme alındı seçin. Gerekirse yeni randevu tercihini işaretleyin.',
                image: '/dokumantasyon/mobileapp/teknisyen/kurulum-2/step-6.png',
              },
              {
                title: '6.a. Konum ve OTP',
                body: 'Konum ve OTP doğrulamasını tamamlayın. Ardından Randevu Tamamla ile bitirin.',
                image: '/dokumantasyon/mobileapp/teknisyen/kurulum-2/step-6a.png',
              },
            ],
          },
          {
            slug: 'kurulum-3',
            title: 'Kurulum - 3',
            platform: 'MobileApp',
            role: 'Teknisyen',
            summary:
              'Kontrol listesinde Hayır ve ödeme alınamadığında: konum doğrulanır, OTP opsiyonel kalır; Randevu Tamamla ile bitirilir.',
            steps: [
              {
                title: '1. Bilgi',
                body: 'Randevu ve müşteri bilgisini kontrol edin. İşleme Başla ile Cihaz adımına geçin.',
                image: '/dokumantasyon/mobileapp/teknisyen/kurulum-3/step-1.png',
              },
              {
                title: '2. Cihaz',
                body: 'Ürünü ve seri numarasını onaylayın.',
                image: '/dokumantasyon/mobileapp/teknisyen/kurulum-3/step-2.png',
              },
              {
                title: '3. Liste',
                body: 'Kontrol sorularını yanıtlayın. En az bir soruya Hayır verildiğinde garanti şartları sağlanmamış sayılır.',
                image: '/dokumantasyon/mobileapp/teknisyen/kurulum-3/step-3.png',
              },
              {
                title: '4. İşlem',
                body: 'Bedelli yapılan işlem ekleyin. Tahsilat tutarı seçilen işlemlerden hesaplanır.',
                image: '/dokumantasyon/mobileapp/teknisyen/kurulum-3/step-4.png',
              },
              {
                title: '5. Tamam',
                body: 'Kontrol listesi karşılanmadı uyarısını ve tahsilat tutarını kontrol edin. Notları girip Son Adıma Geç ile ilerleyin.',
                image: '/dokumantasyon/mobileapp/teknisyen/kurulum-3/step-5.png',
              },
              {
                title: '6. Ödeme alınamadı',
                body: 'Müşteri Ödemesi bölümünde Ödeme alınamadı seçin. Bu durumda OTP doğrulama opsiyoneldir.',
                image: '/dokumantasyon/mobileapp/teknisyen/kurulum-3/step-6.png',
              },
              {
                title: '6.a. Konum ve tamamlama',
                body: 'Konumu doğrulayın. OTP olmadan Randevu Tamamla ile randevuyu bitirin.',
                image: '/dokumantasyon/mobileapp/teknisyen/kurulum-3/step-6a.png',
              },
            ],
          },
          {
            slug: 'ariza-1',
            title: 'Arıza - 1',
            platform: 'MobileApp',
            role: 'Teknisyen',
            summary:
              'Garanti dahilinde arıza randevusunu tek seferde kapatma: seçili ürüne ait işlem, yeni servis kaydı ve sipariş yok.',
            steps: [
              {
                title: '1. Bilgi',
                body: 'Randevu, müşteri ve adres bilgisini kontrol edin. İşleme Başla ile Cihaz adımına geçin.',
                image: '/dokumantasyon/mobileapp/teknisyen/ariza-1/step-1.png',
              },
              {
                title: '2. Cihaz',
                body: 'Servis kaydındaki ürün cihazını seçin ve Cihazı Onayla ile onaylayın.',
                image: '/dokumantasyon/mobileapp/teknisyen/ariza-1/step-2.png',
              },
              {
                title: '3. Liste',
                body: 'Kontrol listesi sorularını yanıtlayın. Değer istenen sorularda ilgili bilgiyi girin.',
                image: '/dokumantasyon/mobileapp/teknisyen/ariza-1/step-3.png',
              },
              {
                title: '3.a. Garanti kapsamı',
                body: 'Garanti dahilinde mi? sorusunu Evet olarak işaretleyin.',
                image: '/dokumantasyon/mobileapp/teknisyen/ariza-1/step-3a.png',
              },
              {
                title: '4. İşlem',
                body: 'Seçili ürüne ait yapılan işlem ekleyin. İlave işlem, parça ve sipariş bu akışta yoktur.',
                image: '/dokumantasyon/mobileapp/teknisyen/ariza-1/step-4.png',
              },
              {
                title: '4.a. İşlem ekleme',
                body: '+ İşlem Ekle ile kataloğu açın. Ürünün işlem kategorisini genişletin.',
                image: '/dokumantasyon/mobileapp/teknisyen/ariza-1/step-4-add.png',
              },
              {
                title: '4.b. İşlem seçimi',
                body: 'Ürüne uygun arıza işlemini (ör. ISI POMPASI ARIZA KEŞİF) işaretleyip ekleyin.',
                image: '/dokumantasyon/mobileapp/teknisyen/ariza-1/step-4-select.png',
              },
              {
                title: '4.c. Eklenen işlemler',
                body: 'Yapılan işlem listelenir. İlave ve parça boş kalır.',
                image: '/dokumantasyon/mobileapp/teknisyen/ariza-1/step-4-listed.png',
              },
              {
                title: '5. Tamam',
                body: 'Yeni randevu gerekli mi? sorusuna Hayır seçin (sipariş sorusu açılmaz). Notları girip ilerleyin.',
                image: '/dokumantasyon/mobileapp/teknisyen/ariza-1/step-5.png',
              },
              {
                title: '6. OTP',
                body: 'Konum ve OTP doğrulamalarını tamamlayın. Randevu Tamamla ile kapatın.',
                image: '/dokumantasyon/mobileapp/teknisyen/ariza-1/step-6.png',
              },
            ],
          },
          {
            slug: 'ariza-2',
            title: 'Arıza - 2',
            platform: 'MobileApp',
            role: 'Teknisyen',
            summary:
              'Garanti dahilinde arıza: yeni randevu ve sipariş gerekli seçilerek tamamlama; servis kaydı Sipariş Bekleniyor durumuna geçer.',
            steps: [
              {
                title: '1. Bilgi',
                body: 'Randevu, müşteri ve adres bilgisini kontrol edin. İşleme Başla ile Cihaz adımına geçin.',
                image: '/dokumantasyon/mobileapp/teknisyen/ariza-1/step-1.png',
              },
              {
                title: '2. Cihaz',
                body: 'Servis kaydındaki ürün cihazını seçin ve Cihazı Onayla ile onaylayın.',
                image: '/dokumantasyon/mobileapp/teknisyen/ariza-1/step-2.png',
              },
              {
                title: '3. Liste',
                body: 'Kontrol listesi sorularını yanıtlayın. Değer istenen sorularda ilgili bilgiyi girin.',
                image: '/dokumantasyon/mobileapp/teknisyen/ariza-1/step-3.png',
              },
              {
                title: '3.a. Garanti kapsamı',
                body: 'Garanti dahilinde mi? sorusunu Evet olarak işaretleyin.',
                image: '/dokumantasyon/mobileapp/teknisyen/ariza-1/step-3a.png',
              },
              {
                title: '4. İşlem',
                body: 'Seçili ürüne ait yapılan işlem ekleyin.',
                image: '/dokumantasyon/mobileapp/teknisyen/ariza-1/step-4.png',
              },
              {
                title: '4.a. İşlem ekleme',
                body: '+ İşlem Ekle ile kataloğu açın. Ürünün işlem kategorisini genişletin.',
                image: '/dokumantasyon/mobileapp/teknisyen/ariza-1/step-4-add.png',
              },
              {
                title: '4.b. İşlem seçimi',
                body: 'Ürüne uygun arıza işlemini işaretleyip ekleyin.',
                image: '/dokumantasyon/mobileapp/teknisyen/ariza-1/step-4-select.png',
              },
              {
                title: '4.c. Eklenen işlemler',
                body: 'Yapılan işlem listelenir.',
                image: '/dokumantasyon/mobileapp/teknisyen/ariza-1/step-4-listed.png',
              },
              {
                title: '5. Yeni randevu ve sipariş',
                body: 'Yeni randevu gerekli mi? ve Sipariş gerekli mi? sorularına Evet seçin. Notları girip Son Adıma Geç ile ilerleyin.',
                image:
                  '/dokumantasyon/mobileapp/teknisyen/yeni-randevu-ve-siparis/step-1.png',
              },
              {
                title: '6. OTP',
                body: 'Konum ve OTP doğrulamalarını tamamlayın. Randevu Tamamla sonrası servis kaydı Sipariş Bekleniyor olur.',
                image: '/dokumantasyon/mobileapp/teknisyen/ariza-1/step-6.png',
              },
            ],
          },
          {
            slug: 'teknisyen-siparis-1',
            title: 'Teknisyen Sipariş - 1',
            platform: 'MobileApp',
            role: 'Teknisyen',
            summary:
              'Sipariş Bekleniyor servis kaydından parça siparişi oluşturma; teknik servis onay kuyruğuna düşer.',
            steps: [
              {
                title: '1. Servis kaydı',
                body: 'Servis kaydı detayında Sipariş Ver ile sipariş oluşturma ekranına geçin.',
                image:
                  '/dokumantasyon/mobileapp/teknisyen/teknisyen-siparis-1/step-1.png',
              },
              {
                title: '2. Parça seçimi',
                body: 'Ürüne ait parçaları seçip adetleri girin.',
                image:
                  '/dokumantasyon/mobileapp/teknisyen/teknisyen-siparis-1/step-2.png',
              },
              {
                title: '3. Sipariş sonucu',
                body: 'Oluşturulan sipariş Teknik servis onayı bekliyor durumunda görünür.',
                image:
                  '/dokumantasyon/mobileapp/teknisyen/teknisyen-siparis-1/step-3.png',
              },
            ],
          },
          {
            slug: 'ariza-2a',
            title: 'Arıza - 2a',
            platform: 'MobileApp',
            role: 'Teknisyen',
            summary:
              'Sipariş parçaları teslim edildikten sonra takip arızası: siparişlerden parça, işlem ve yeni randevu olmadan tamamlama.',
            steps: [
              {
                title: '1. Bilgi',
                body: 'Takip randevusu, müşteri ve adres bilgisini kontrol edin. İleri ile Cihaz adımına geçin.',
                image: '/dokumantasyon/mobileapp/teknisyen/ariza-2a/step-1.png',
              },
              {
                title: '2. Cihaz',
                body: 'Servis kaydındaki ürün cihazını seçin ve Cihazı Onayla ile onaylayın.',
                image: '/dokumantasyon/mobileapp/teknisyen/ariza-1/step-2.png',
              },
              {
                title: '3. Liste',
                body: 'Kontrol listesi sorularını yanıtlayın.',
                image: '/dokumantasyon/mobileapp/teknisyen/ariza-1/step-3.png',
              },
              {
                title: '3.a. Garanti kapsamı',
                body: 'Garanti dahilinde mi? sorusunu Evet olarak işaretleyin.',
                image: '/dokumantasyon/mobileapp/teknisyen/ariza-1/step-3a.png',
              },
              {
                title: '4. Parça ekleme',
                body: 'İşlem adımında Değiştirilen Parçalar → Siparişlerden seç ile sipariş parçalarına gidin.',
                image:
                  '/dokumantasyon/mobileapp/teknisyen/ariza-2a/step-3-addpart.png',
              },
              {
                title: '4.a. Siparişlerden parça',
                body: 'Tamamlanan siparişten parçaları işaretleyip listeye ekleyin.',
                image:
                  '/dokumantasyon/mobileapp/teknisyen/ariza-2a/step-3-siparis.png',
              },
              {
                title: '5. İşlem',
                body: 'Ürüne ilgili yapılan işlemi ekleyin.',
                image: '/dokumantasyon/mobileapp/teknisyen/ariza-2a/step-4.png',
              },
              {
                title: '6. Tamam',
                body: 'Yeni randevu gerekli mi? sorusuna Hayır seçin. Notları girip Son Adıma Geç ile ilerleyin.',
                image: '/dokumantasyon/mobileapp/teknisyen/ariza-2a/step-5.png',
              },
              {
                title: '7. OTP',
                body: 'Konum ve OTP doğrulamalarını tamamlayın. Randevu Tamamla ile kapatın.',
                image: '/dokumantasyon/mobileapp/teknisyen/ariza-1/step-6.png',
              },
            ],
          },
          {
            slug: 'foto-ekleme',
            title: 'Foto Ekleme',
            platform: 'MobileApp',
            role: 'Teknisyen',
            summary:
              'İşlem adımında randevuya fotoğraf ekleme: kamera veya galeri, en fazla 4 fotoğraf, tamamlamada sunucuya gönderim.',
            steps: [
              {
                title: '1. Fotoğraflar bölümü',
                body: 'İşlem adımında Fotoğraflar kartından + Fotoğraf Ekle ile ekleme ekranına geçin.',
                image: '/dokumantasyon/mobileapp/teknisyen/foto-ekleme/step-1.png',
              },
              {
                title: '2. Fotoğraf ekleme ekranı',
                body: 'Fotoğraf Çek veya Galeriden Ekle ile görsel ekleyin. Sayaç en fazla 4 fotoğrafı gösterir.',
                image: '/dokumantasyon/mobileapp/teknisyen/foto-ekleme/step-2.png',
              },
              {
                title: '3. Kamera',
                body: 'Fotoğraf Çek ile cihaz kamerası açılır. Çekimi onaylayınca fotoğraf listeye eklenir.',
                image: '/dokumantasyon/mobileapp/teknisyen/foto-ekleme/step-3.png',
              },
              {
                title: '4. Eklenen fotoğraflar',
                body: 'Eklenen görseller ızgarada listelenir; kaynak (kamera/galeri) rozeti görünür. Büyütme ve silme yapılabilir.',
                image: '/dokumantasyon/mobileapp/teknisyen/foto-ekleme/step-4.png',
              },
            ],
          },
          {
            slug: 'ilave-islem-ekleme',
            title: 'İlave İşlem Ekleme',
            platform: 'MobileApp',
            role: 'Teknisyen',
            summary:
              'İşlem adımında katalog dışı ilave işlem ekleme: ad, fiyat ve isteğe bağlı açıklama.',
            steps: [
              {
                title: '1. İlave İşlemler bölümü',
                body: 'İşlem adımında İlave İşlemler kartından + İlave İşlem Ekle ile formu açın.',
                image:
                  '/dokumantasyon/mobileapp/teknisyen/ilave-islem-ekleme/step-1.png',
              },
              {
                title: '2. İlave işlem formu',
                body: 'İşlem adı ve fiyat zorunludur. Açıklama isteğe bağlıdır.',
                image:
                  '/dokumantasyon/mobileapp/teknisyen/ilave-islem-ekleme/step-2.png',
              },
              {
                title: '3. Bilgileri girme',
                body: 'Ad, fiyat ve açıklamayı doldurup Ekle ile kaydedin.',
                image:
                  '/dokumantasyon/mobileapp/teknisyen/ilave-islem-ekleme/step-3.png',
              },
              {
                title: '4. Eklenen ilave işlemler',
                body: 'Kayıtlı ilave işlemler listelenir. Düzenle veya Sil ile güncelleyebilirsiniz.',
                image:
                  '/dokumantasyon/mobileapp/teknisyen/ilave-islem-ekleme/step-4.png',
              },
            ],
          },
          {
            slug: 'yeni-randevu-ve-siparis',
            title: 'Yeni Randevu ve Sipariş',
            platform: 'MobileApp',
            role: 'Teknisyen',
            summary:
              'Tamam adımında yeni randevu gerektiğinde sipariş sorusunun görünmesi.',
            steps: [
              {
                title: '1. Yeni randevu ve sipariş',
                body: 'Tamam adımında Yeni randevu gerekli mi? sorusuna Evet derseniz Sipariş gerekli mi? seçenekleri açılır.',
                image:
                  '/dokumantasyon/mobileapp/teknisyen/yeni-randevu-ve-siparis/step-1.png',
              },
            ],
          },
          {
            slug: 'manuel-konum-dogrulama',
            title: 'Manuel Konum Doğrulama',
            platform: 'MobileApp',
            role: 'Teknisyen',
            summary:
              'OTP adımında GPS konum alınamazsa Konum Doğrula birkaç kez denenir; ardından Manuel Konum Al ile randevu adresinden konum kaydedilir.',
            steps: [
              {
                title: '1. Manuel Konum Al',
                body: 'Konum Doğrula iki kez başarısız olunca Manuel Konum Al butonu görünür.',
                image:
                  '/dokumantasyon/mobileapp/teknisyen/manuel-konum-dogrulama/step-1.png',
              },
              {
                title: '2. Onay',
                body: 'Manuel Konum Al ile açılan uyarıda Evet ile devam edin.',
                image:
                  '/dokumantasyon/mobileapp/teknisyen/manuel-konum-dogrulama/step-2.png',
              },
              {
                title: '3. Konum doğrulandı',
                body: 'Konum randevu adresinden manuel olarak işaretlenir; ardından OTP ile tamamlayabilirsiniz.',
                image:
                  '/dokumantasyon/mobileapp/teknisyen/manuel-konum-dogrulama/step-3.png',
              },
            ],
          },
        ],
      },
      {
        slug: 'teknik-servis',
        title: 'TeknikServis',
        docs: [
          {
            slug: 'yasal-onay',
            title: 'Yasal Onay',
            platform: 'MobileApp',
            role: 'TeknikServis',
            summary:
              'Teknik servis hesabı için yasal kapı: dil seçimi (TR/EN), belge okuma, onaylar, giriş ve müşteri verileri taahhütnamesi. Pre-login ekranları teknisyenle ortaktır; giriş sonrası anasayfa teknik servis düzenindedir.',
            steps: [
              {
                title: '1. Yasal karşılama (TR)',
                body: 'İlk açılışta logo, kısa açıklama ve üç belge linki görünür. Sağ üstten dil seçilir. İki onay kutusu işaretlenmeden devam edilmez.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/yasal-onay/step-1.png',
              },
              {
                title: '2. Dil seçimi — English',
                body: 'English seçilince açıklama, belge başlıkları, onay metinleri ve buton İngilizceye döner. Onay kutuları sıfırlanır.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/yasal-onay/step-2.png',
              },
              {
                title: '3. Belge okuma (TR)',
                body: 'Kullanım Koşulları / KVKK / Gizlilik metni okunur.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/yasal-onay/step-3.png',
              },
              {
                title: '3.a. Belge okuma (EN)',
                body: 'Dil English iken belge gövdesi ve başlık İngilizce gelir.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/yasal-onay/step-3a.png',
              },
              {
                title: '4. Giriş (TR)',
                body: 'Onaylardan sonra teknik servis kullanıcısı ile giriş yapılır.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/yasal-onay/step-4.png',
              },
              {
                title: '4.a. Giriş (EN)',
                body: 'Yasal ekranda English seçildiyse giriş ekranı da İngilizcedir.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/yasal-onay/step-4a.png',
              },
              {
                title: '5. Taahhütname (TR)',
                body: 'Teknik servis girişinden sonra Müşteri Verileri Taahhütnamesi zorunludur (teknisyenle aynı belge tipi).',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/yasal-onay/step-5.png',
              },
              {
                title: '5.a. Taahhütname (EN)',
                body: 'Dil English iken taahhüt metni İngilizce görünür.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/yasal-onay/step-5a.png',
              },
              {
                title: '6. Bildirim izni',
                body: 'Taahhüt sonrası bildirim ön-açıklaması sorulabilir.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/yasal-onay/step-6.png',
              },
              {
                title: '7. Anasayfa',
                body: 'Teknik servis anasayfasında rol Teknik Servis görünür; Servis Kayıtları ve Açık Randevular panelleri açılır.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/yasal-onay/step-7.png',
              },
            ],
          },
          {
            slug: 'login-1',
            title: 'Login - 1',
            platform: 'MobileApp',
            role: 'TeknikServis',
            summary:
              'Teknik servis hesabıyla uygulamaya ilk giriş: kullanıcı adı/şifre ve anasayfa (Servis Kayıtları / Açık Randevular).',
            steps: [
              {
                title: '1. Giriş ekranı',
                body: 'Yasal onaydan sonra SM Yönetim Sistemi giriş ekranı açılır.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/login-1/step-1.png',
              },
              {
                title: '2. Bilgileri girme',
                body: 'Teknik servis kullanıcı adı ve şifresini girip Giriş Yap’a basın.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/login-1/step-2.png',
              },
              {
                title: '3. Anasayfa',
                body: 'Giriş sonrası üstte Teknik Servis rolü; Servis Kayıtları ve Açık Randevular panelleri görünür.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/login-1/step-3.png',
              },
            ],
          },
          {
            slug: 'login-2',
            title: 'Login - 2',
            platform: 'MobileApp',
            role: 'TeknikServis',
            summary:
              'Teknik servis oturumundayken teknisyen hesabını ikinci kullanıcı olarak ekleme; eklenen hesap aktif olur ve Hesap Yönetimi’nde listelenir.',
            steps: [
              {
                title: '1. Teknik servis anasayfa',
                body: 'Önce teknik servis hesabıyla giriş yapılmış olmalıdır.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/login-2/step-1.png',
              },
              {
                title: '2. Menü',
                body: 'Sağ alttaki ⋮ menüsünden Profil ve hesap’ı seçin.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/login-2/step-2.png',
              },
              {
                title: '3. Hesap Yönetimi',
                body: 'Yeni Kullanıcı Ekle ile ikinci hesap ekleme ekranına geçin.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/login-2/step-3.png',
              },
              {
                title: '4. Yeni Kullanıcı Ekle',
                body: 'Teknisyen kullanıcı adı ve şifresi için form açılır.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/login-2/step-4.png',
              },
              {
                title: '5. Teknisyen bilgileri',
                body: 'Teknisyen hesabını girip Giriş Yap ile ekleyin.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/login-2/step-5.png',
              },
              {
                title: '6. Eklenen hesap aktif',
                body: 'İkinci hesap eklendikten sonra oturum teknisyen hesabına geçer.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/login-2/step-6.png',
              },
              {
                title: '7. İki hesap listede',
                body: 'Hesap Yönetimi’nde teknik servis ve teknisyen hesapları birlikte görünür.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/login-2/step-7.png',
              },
            ],
          },
          {
            slug: 'hesaplar-arasi-gecis',
            title: 'Hesaplar Arası Geçiş',
            platform: 'MobileApp',
            role: 'TeknikServis',
            summary:
              'Aynı cihazda kayıtlı teknik servis ve teknisyen hesapları arasında Hesap Yönetimi üzerinden geçiş.',
            steps: [
              {
                title: '1. Hesap Yönetimi',
                body: 'Menü → Profil ve hesap. Kullanıcı Değiştir altında kayıtlı hesaplar listelenir; yeşil olan aktif hesaptır.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/hesaplar-arasi-gecis/step-1.png',
              },
              {
                title: '2. Teknik servise geç',
                body: 'Teknik Servis satırına dokunun; anasayfa Servis Kayıtları düzenine döner.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/hesaplar-arasi-gecis/step-2.png',
              },
              {
                title: '3. Aktif teknik servis',
                body: 'Hesap Yönetimi’nde Teknik Servis hesabı aktif (yeşil) görünür.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/hesaplar-arasi-gecis/step-3.png',
              },
              {
                title: '4. Teknisyene geç',
                body: 'Teknisyen satırına dokunun; Randevular anasayfası açılır.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/hesaplar-arasi-gecis/step-4.png',
              },
            ],
          },
          {
            slug: 'randevu-olusturma',
            title: 'Randevu Oluşturma',
            platform: 'MobileApp',
            role: 'TeknikServis',
            summary:
              'Anasayfadaki Randevu Bekleniyor servis kaydından tarih, saat ve teknisyen seçerek randevu oluşturma.',
            steps: [
              {
                title: '1. Anasayfa',
                body: 'Servis Kayıtları listesinde Randevu Bekleniyor durumundaki kayda dokunun.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/randevu-olusturma/step-1.png',
              },
              {
                title: '2. Servis kaydı detayı',
                body: 'Randevu Oluştur ile randevu oluşturma ekranına geçin.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/randevu-olusturma/step-2.png',
              },
              {
                title: '3. Tarih seçimi',
                body: 'Takvimden randevu tarihini seçip Saat seçimine geç ile ilerleyin.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/randevu-olusturma/step-3.png',
              },
              {
                title: '4. Saat seçimi',
                body: 'Uygun saati seçip Teknisyen seçimine geç ile ilerleyin.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/randevu-olusturma/step-4.png',
              },
              {
                title: '5. Teknisyen seçimi',
                body: 'Teknisyeni seçip Randevu oluştur ile kaydı tamamlayın.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/randevu-olusturma/step-5.png',
              },
              {
                title: '6. Sonuç',
                body: 'Randevu oluşturuldu onayı görünür; kayıt açık randevuya dönüşür.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/randevu-olusturma/step-6.png',
              },
            ],
          },
          {
            slug: 'randevu-icin-siparis-verme',
            title: 'Randevu için Sipariş Verme',
            platform: 'MobileApp',
            role: 'TeknikServis',
            summary:
              'Anasayfadaki Sipariş Bekleniyor servis kaydından Sipariş Ver ile parça siparişi oluşturma; sipariş admin onayına düşer.',
            steps: [
              {
                title: '1. Anasayfa',
                body: 'Servis Kayıtları listesinde Sipariş Bekleniyor durumundaki arıza kaydına dokunun.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/randevu-icin-siparis-verme/step-1.png',
              },
              {
                title: '2. Servis kaydı detayı',
                body: 'Sipariş Ver ile sipariş oluşturma ekranına geçin.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/randevu-icin-siparis-verme/step-2.png',
              },
              {
                title: '3. Parça seçimi',
                body: 'Ürüne göre parçaları ekleyip adetleri ayarlayın; gerekirse not girin.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/randevu-icin-siparis-verme/step-3.png',
              },
              {
                title: '4. Sipariş sonucu',
                body: 'Oluşturulan sipariş OnayBekliyor durumunda admin onay kuyruğuna alınır.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/randevu-icin-siparis-verme/step-4.png',
              },
            ],
          },
          {
            slug: 'teknisyen-siparis-onay',
            title: 'Teknisyen Sipariş Onay',
            platform: 'MobileApp',
            role: 'TeknikServis',
            summary:
              'Teknisyenin oluşturduğu siparişi teknik servisin onaylayıp admin kuyruğuna göndermesi.',
            steps: [
              {
                title: '1. Sipariş Onayları',
                body: 'Menüden Sipariş Onayları listesinde bekleyen siparişi açın.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/teknisyen-siparis-onay/step-1.png',
              },
              {
                title: '2. Onay',
                body: 'Parça ve notları kontrol edin; Onayla ile onaylayın. Durum OnayBekliyor olur, sipariş admin onay kuyruğuna düşer.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/teknisyen-siparis-onay/step-2.png',
              },
            ],
          },
          {
            slug: 'teknik-servis-kargo-teslim-alma',
            title: 'Kargo Teslim Alma',
            platform: 'MobileApp',
            role: 'TeknikServis',
            summary:
              'Kargodaki siparişi teslim alma; sipariş Tamamlandı olur, servis kaydı Randevu Bekleniyor durumuna geçer.',
            steps: [
              {
                title: '1. Kargo teslim',
                body: 'Sipariş detayında Kargo teslim alındı ile teslimi onaylayın.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/teknik-servis-kargo-teslim-alma/step-4.png',
              },
              {
                title: '2. Teslim sonrası',
                body: 'Sipariş Tamamlandı olur; servis kaydı Randevu Bekleniyor durumuna geçer.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/teknik-servis-kargo-teslim-alma/step-5.png',
              },
            ],
          },
          {
            slug: 'dogrudan-siparis',
            title: 'Doğrudan Sipariş',
            platform: 'MobileApp',
            role: 'TeknikServis',
            summary:
              'Doğrudan sipariş oluşturma: taslak veya Sipariş Oluştur ile giriş, parça filtre/seçim, galeri fotoğrafı ve not; admin onay/kargo/fatura sonrası Kargoda ve teslim alma.',
            steps: [
              {
                title: '1. Sipariş taslakları',
                body: 'Siparişler ekranında yarım kalan eklemeler taslak olarak saklanır; Doğrudan alım taslağından devam edin.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/dogrudan-siparis/step-1.png',
              },
              {
                title: '1.a. Taslak modalı',
                body: 'Kayıtlı taslak varsa Taslak bulundu sorulur; Yeni başla ile taslağı bırakıp sıfırdan devam edin.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/dogrudan-siparis/step-1a.png',
              },
              {
                title: '1.b. Sipariş Oluştur',
                body: 'Sipariş Oluştur ile sipariş türü ekranına girip Doğrudan Sipariş’i seçin.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/dogrudan-siparis/step-1b.png',
              },
              {
                title: '2. Parça filtreleme',
                body: 'Parça filtresi ile kategori veya ürüne göre listeyi daraltın.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/dogrudan-siparis/step-2.png',
              },
              {
                title: '3. Parça seçimi',
                body: 'Parça seç ile parçaları ekleyip adetleri ayarlayın.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/dogrudan-siparis/step-3.png',
              },
              {
                title: '4. Fotoğraf ve not',
                body: 'Galeriden fotoğraf ekleyin; gerekirse not girip siparişi oluşturun.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/dogrudan-siparis/step-4.png',
              },
              {
                title: '5. Onay Bekleyen',
                body: 'Oluşan doğrudan sipariş Onay Bekleyen sekmesinde admin onayını bekler.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/dogrudan-siparis/step-5.png',
              },
              {
                title: '6. Kargo Bekleyen',
                body: 'Admin onayından sonra sipariş Kargo Bekleyen sekmesine düşer.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/dogrudan-siparis/step-6.png',
              },
              {
                title: '7. Fatura Bekleyen',
                body: 'Fatura bilgisi girilene kadar sipariş Fatura Bekleyen sekmesinde de görünür.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/dogrudan-siparis/step-7.png',
              },
              {
                title: '8. Kargoda',
                body: 'Kargo bilgisi girildikten sonra sipariş Kargoda sekmesine geçer.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/dogrudan-siparis/step-8.png',
              },
              {
                title: '9. Kargo teslim',
                body: 'Sipariş detayında Kargo teslim alındı ile teslimi onaylayın.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/dogrudan-siparis/step-9.png',
              },
              {
                title: '10. Tamamlanan',
                body: 'Teslim sonrası sipariş Tamamlanan sekmesinde listelenir.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/dogrudan-siparis/step-10.png',
              },
            ],
          },
          {
            slug: 'konsinye-siparis',
            title: 'Konsinye Sipariş',
            platform: 'MobileApp',
            role: 'TeknikServis',
            summary:
              'Konsinye sipariş oluşturma: taslak veya Sipariş Oluştur ile giriş, parça filtre/seçim, galeri fotoğrafı ve not; admin onay/kargo/fatura sonrası Kargoda ve teslim alma.',
            steps: [
              {
                title: '1. Sipariş taslakları',
                body: 'Siparişler ekranında yarım kalan eklemeler taslak olarak saklanır; Konsinye taslağından devam edin.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/konsinye-siparis/step-1.png',
              },
              {
                title: '1.a. Taslak modalı',
                body: 'Kayıtlı taslak varsa Taslak bulundu sorulur; Yeni başla ile taslağı bırakıp sıfırdan devam edin.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/konsinye-siparis/step-1a.png',
              },
              {
                title: '1.b. Sipariş Oluştur',
                body: 'Sipariş Oluştur ile sipariş türü ekranına girip Konsinye’yi seçin.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/konsinye-siparis/step-1b.png',
              },
              {
                title: '2. Parça filtreleme',
                body: 'Parça filtresi ile kategori veya ürüne göre listeyi daraltın.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/konsinye-siparis/step-2.png',
              },
              {
                title: '3. Parça seçimi',
                body: 'Parça seç ile parçaları ekleyip adetleri ayarlayın.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/konsinye-siparis/step-3.png',
              },
              {
                title: '4. Fotoğraf ve not',
                body: 'Galeriden fotoğraf ekleyin; gerekirse not girip siparişi oluşturun.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/konsinye-siparis/step-4.png',
              },
              {
                title: '5. Onay Bekleyen',
                body: 'Oluşan konsinye sipariş Onay Bekleyen sekmesinde admin onayını bekler.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/konsinye-siparis/step-5.png',
              },
              {
                title: '6. Kargo Bekleyen',
                body: 'Admin onayından sonra sipariş Kargo Bekleyen sekmesine düşer.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/konsinye-siparis/step-6.png',
              },
              {
                title: '7. Fatura Bekleyen',
                body: 'Fatura bilgisi girilene kadar sipariş Fatura Bekleyen sekmesinde de görünür.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/konsinye-siparis/step-7.png',
              },
              {
                title: '8. Kargoda',
                body: 'Kargo bilgisi girildikten sonra sipariş Kargoda sekmesine geçer.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/konsinye-siparis/step-8.png',
              },
              {
                title: '9. Kargo teslim',
                body: 'Sipariş detayında Kargo teslim alındı ile teslimi onaylayın.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/konsinye-siparis/step-9.png',
              },
              {
                title: '10. Tamamlanan',
                body: 'Teslim sonrası sipariş Tamamlanan sekmesinde listelenir.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/konsinye-siparis/step-10.png',
              },
            ],
          },
          {
            slug: 'iade-kargo-1',
            title: 'İade Kargo - 1',
            platform: 'MobileApp',
            role: 'TeknikServis',
            summary:
              'Arızada değiştirilen arızalı parçaların fabrikaya iadesi: menü bildirimi, kargo bilgisi girişi, Kargoda ve Tamamlandı takibi.',
            steps: [
              {
                title: '1. Menü',
                body: 'Menüde İade Kargoları üzerinde bekleyen kayıt sayısı (badge) görünür.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/iade-kargo-1/step-1.png',
              },
              {
                title: '2. İade Kargoları',
                body: 'Kargo Bekliyor sekmesinde iade kaydını açın.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/iade-kargo-1/step-2.png',
              },
              {
                title: '3. Kargo bilgisi',
                body: 'Kargo bilgisi gir ile firma ve takip numarasını kaydedin.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/iade-kargo-1/step-3.png',
              },
              {
                title: '4. Kargoda',
                body: 'Kayıt Kargoda sekmesine geçer; kargo firması ve takip no listede görünür.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/iade-kargo-1/step-4.png',
              },
              {
                title: '5. Tamamlandı',
                body: 'Fabrikada teslim sonrası kayıt Tamamlandı sekmesinde listelenir.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/iade-kargo-1/step-5.png',
              },
            ],
          },
          {
            slug: 'iade-faturalari',
            title: 'İade Faturaları',
            platform: 'MobileApp',
            role: 'TeknikServis',
            summary:
              'Öz stoktan iade talebi oluşturma, onay sonrası fatura bekleyen kayıt ve mali fatura numarası girişi.',
            steps: [
              {
                title: '1. Menü',
                body: 'Menüde İade Faturaları üzerinde bekleyen kayıt sayısı (badge) görünür.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/iade-faturalari/step-1.png',
              },
              {
                title: '2. İade Faturaları',
                body: 'İade Oluştur ile öz stok iade talebini başlatın.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/iade-faturalari/step-2.png',
              },
              {
                title: '3. Parça seçimi',
                body: 'Stoğunuzdaki parçaları seçip iade talebi oluşturun.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/iade-faturalari/step-3.png',
              },
              {
                title: '4. Onay Bekleyen',
                body: 'Oluşan talep Onay Bekleyen sekmesinde listelenir.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/iade-faturalari/step-4.png',
              },
              {
                title: '5. Fatura Bekleyen',
                body: 'Onay sonrası kayıt Fatura Bekleyen sekmesine geçer.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/iade-faturalari/step-5.png',
              },
              {
                title: '6. Fatura girişi',
                body: 'Detayda mali fatura numarasını girip kaydedin.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/iade-faturalari/step-6.png',
              },
              {
                title: '7. Tamamlanan',
                body: 'Fatura kaydı sonrası talep Tamamlanan sekmesinde görünür.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/iade-faturalari/step-7.png',
              },
            ],
          },
          {
            slug: 'iade-kargo-2',
            title: 'İade Kargo - 2',
            platform: 'MobileApp',
            role: 'TeknikServis',
            summary:
              'Öz stok iade faturası onayından oluşan iade kargonun menü bildirimi, kargo bilgisi girişi, Kargoda ve Tamamlandı takibi.',
            steps: [
              {
                title: '1. Menü',
                body: 'İade fatura onayı sonrası menüde İade Kargoları badge’i görünür.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/iade-kargo-2/step-1.png',
              },
              {
                title: '2. Kargo Bekliyor',
                body: 'Kayıt İade Fatura kaynağıyla Kargo Bekliyor sekmesinde listelenir.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/iade-kargo-2/step-2.png',
              },
              {
                title: '3. Kargo bilgisi',
                body: 'Kargo bilgisi gir ile firma ve takip numarasını kaydedin.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/iade-kargo-2/step-3.png',
              },
              {
                title: '4. Kargoda',
                body: 'Kayıt Kargoda sekmesine geçer; firma ve takip no listede görünür.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/iade-kargo-2/step-4.png',
              },
              {
                title: '5. Tamamlandı',
                body: 'Fabrikada teslim sonrası kayıt Tamamlandı sekmesinde listelenir.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/iade-kargo-2/step-5.png',
              },
            ],
          },
          {
            slug: 'hakedisler',
            title: 'Hakedişler',
            platform: 'MobileApp',
            role: 'TeknikServis',
            summary:
              'Onaylı hakedişi Fatura Bekleyen’de görüntüleme, içerik detayı ve fatura numarası girişi; ardından Tamamlanan takibi.',
            steps: [
              {
                title: '1. Menü',
                body: 'Menüde Hakedişler üzerinde fatura bekleyen kayıt sayısı (badge) görünür.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/hakedisler/step-1.png',
              },
              {
                title: '2. Fatura Bekleyen',
                body: 'Fatura Bekleyen Hakedişler listesinde kaydı açın veya Fatura Ekle’ye basın.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/hakedisler/step-2.png',
              },
              {
                title: '3. Hakediş detayı',
                body: 'Detayda işlemler, yol bedeli ve toplam tutarı inceleyin.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/hakedisler/step-3.png',
              },
              {
                title: '4. Fatura ekle',
                body: 'Fatura Bilgisi Ekle ile mali fatura numarasını kaydedin.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/hakedisler/step-4.png',
              },
              {
                title: '5. Tamamlanan',
                body: 'Fatura sonrası hakediş Tamamlanan Hakedişler’de listelenir.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/hakedisler/step-5.png',
              },
            ],
          },
          {
            slug: 'cari-hareketler',
            title: 'Cari Hareketler',
            platform: 'MobileApp',
            role: 'TeknikServis',
            summary:
              'Cari özet ve hareketler: doğrudan sipariş borç (−), hakediş ve iade faturası alacak (+). Admin ve teknik servis aynı işaretleri görür. Konsinye sipariş bu listeye düşmez.',
            steps: [
              {
                title: '1. Menü',
                body: 'Menüden Cari Hareketler’e girin.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/cari-hareketler/step-1.png',
              },
              {
                title: '2. Özet',
                body: 'Üstte Borç, Alacak ve Bakiye aynı rakamlarla görünür.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/cari-hareketler/step-2.png',
              },
              {
                title: '3. Sipariş (borç)',
                body: 'Doğrudan sipariş faturası sonrası Sipariş satırı borç olarak (−) listelenir.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/cari-hareketler/step-3.png',
              },
              {
                title: '4. Hakediş (alacak)',
                body: 'Hakediş faturası kesildikten sonra Hakediş satırı alacak olarak (+) listelenir.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/cari-hareketler/step-4.png',
              },
              {
                title: '5. İade Faturası (alacak)',
                body: 'İade faturası mali fatura sonrası İade Faturası satırı alacak olarak (+) listelenir.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/cari-hareketler/step-5.png',
              },
            ],
          },
          {
            slug: 'gonderim-test-to-a',
            title: 'Gönderim: Test → A Teknik',
            platform: 'MobileApp',
            role: 'TeknikServis',
            summary:
              'Admin Test Teknik Servis’ten A Teknik’e gönderim oluşturur. Gönderen kargo bilgisi girer; alıcı teslim alır.',
            steps: [
              {
                title: '1. Menü',
                body: 'Gönderen teknik serviste Menü → Gönderimler (aksiyon badge’i görünebilir).',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/gonderim-test-to-a/step-1.png',
              },
              {
                title: '2. Gidenler',
                body: 'Gidenler’de admin’in oluşturduğu kayıt Kargo Bekliyor olarak listelenir.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/gonderim-test-to-a/step-2.png',
              },
              {
                title: '3. Gönderim detayı',
                body: 'Detayda alıcı ve adresi kontrol edin; Kargo bilgisi gir ile devam edin.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/gonderim-test-to-a/step-3.png',
              },
              {
                title: '4. Kargo bilgisi',
                body: 'Firma ve takip numarasını girip Kargoya ver ile alıcıya iletin.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/gonderim-test-to-a/step-4.png',
              },
              {
                title: '5. Alıcı menü',
                body: 'Alıcı teknik serviste Menü → Gönderimler.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/gonderim-test-to-a/step-5.png',
              },
              {
                title: '6. Gelenler',
                body: 'Gelenler’de kayıt Alıcı Bekliyor durumundadır.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/gonderim-test-to-a/step-6.png',
              },
              {
                title: '7. Teslim al',
                body: 'Detayda Teslim alındı ile stoku konsinye olarak kabul edin.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/gonderim-test-to-a/step-7.png',
              },
              {
                title: '8. Tamamlandı',
                body: 'Gönderim Tamamlandı olur.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/gonderim-test-to-a/step-8.png',
              },
            ],
          },
          {
            slug: 'gonderim-a-to-test',
            title: 'Gönderim: A Teknik → Test',
            platform: 'MobileApp',
            role: 'TeknikServis',
            summary:
              'Admin A Teknik’ten Test Teknik Servis’e gönderim oluşturur. Gönderen kargo girer; Test teslim alır.',
            steps: [
              {
                title: '1. Menü',
                body: 'Gönderen (A Teknik) Menü → Gönderimler.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/gonderim-a-to-test/step-1.png',
              },
              {
                title: '2. Gidenler',
                body: 'Gidenler’de Kargo Bekliyor kaydı görünür.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/gonderim-a-to-test/step-2.png',
              },
              {
                title: '3. Gönderim detayı',
                body: 'Detayda alıcı Test Teknik Servis ve adresi görünür.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/gonderim-a-to-test/step-3.png',
              },
              {
                title: '4. Kargo bilgisi',
                body: 'Firma ve takip no girip Kargoya ver.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/gonderim-a-to-test/step-4.png',
              },
              {
                title: '5. Gelenler',
                body: 'Test Teknik Servis Gelenler’de Alıcı Bekliyor kaydını açar.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/gonderim-a-to-test/step-5.png',
              },
              {
                title: '6. Teslim al',
                body: 'Detayda Teslim alındı ile kabul edin.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/gonderim-a-to-test/step-6.png',
              },
              {
                title: '7. Tamamlandı',
                body: 'Gönderim Tamamlandı olur.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/gonderim-a-to-test/step-7.png',
              },
            ],
          },
          {
            slug: 'cihaz-degisim',
            title: 'Cihaz Değişim',
            platform: 'MobileApp',
            role: 'TeknikServis',
            summary:
              'Tamamlanmış randevudaki cihaz için değişim talebi oluşturma; admin onayından sonra Onaylanan’da takip (iade kargo oluşur).',
            steps: [
              {
                title: '1. Menü',
                body: 'Menüden Cihaz Değişim’e girin.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/cihaz-degisim/step-1.png',
              },
              {
                title: '2. Randevu seç',
                body: 'Talep Oluştur ile tamamlanmış randevuyu seçin.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/cihaz-degisim/step-2.png',
              },
              {
                title: '3. Cihaz seç',
                body: 'Randevudaki cihazı seçip Talep Oluştur ile gönderin.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/cihaz-degisim/step-3.png',
              },
              {
                title: '4. Onay Bekleyen',
                body: 'Talep Onay Bekleyen listesinde görünür.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/cihaz-degisim/step-4.png',
              },
              {
                title: '5. Detay',
                body: 'Detayda randevu, seri no ve durum kontrol edilir.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/cihaz-degisim/step-5.png',
              },
              {
                title: '6. Onaylanan',
                body: 'Admin onayından sonra kayıt Onaylanan sekmesine düşer.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/cihaz-degisim/step-6.png',
              },
              {
                title: '7. Onaylandı detay',
                body: 'Onay sonrası iade kargo numarası detayda görünür.',
                image:
                  '/dokumantasyon/mobileapp/teknik-servis/cihaz-degisim/step-7.png',
              },
            ],
          },
        ],
      },
    ],
  },
];

/**
 * @param {string} platformSlug
 * @param {string} roleSlug
 * @param {string} docSlug
 * @returns {DocArticle | null}
 */
export function findDoc(platformSlug, roleSlug, docSlug) {
  const cat = DOCS_TREE.find((c) => c.slug === platformSlug);
  if (!cat) return null;
  const sub = cat.subcategories.find((s) => s.slug === roleSlug);
  if (!sub) return null;
  return sub.docs.find((d) => d.slug === docSlug) || null;
}

/**
 * @returns {{ platform: string, role: string, doc: string } | null}
 */
export function getDefaultDocPath() {
  const cat = DOCS_TREE[0];
  const sub = cat?.subcategories?.[0];
  const doc = sub?.docs?.[0];
  if (!cat || !sub || !doc) return null;
  return { platform: cat.slug, role: sub.slug, doc: doc.slug };
}

/**
 * @param {{ platform: string, role: string, doc: string }} path
 */
export function docPathToUrl(path) {
  return `/dokumantasyon/${path.platform}/${path.role}/${path.doc}`;
}
